module.exports = __webpack_public_path__ + "static/media/food.8cf27d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/food.jpg
// module id = 383
// module chunks = 4